'use client';

import {
  amplitudeSendEvent,
  GTM_NOTSET_STRING,
  getScreenName,
  pushDataLayer,
} from '@musinsa/frontend-utils';
import { Divider, IcInfo, IconButton, PriceTypography, Typography } from '@musinsa/mds';
import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import { track } from '@musinsa/packages-event-snowplow';
import { useQuery } from '@tanstack/react-query';
import { getPaths } from '../../common';
import { ExpectedEarningsInfoSheet } from '../../common/components';
import { useNavigate } from '../../common/hooks/useNavigate';
import { curatorQueries } from '../../query-factory';
import { SNOWPLOW_SCHEME } from '../../snowplow';
import { CampaignShortcutGroup } from '../components/CampaignShortcutGroup';

export const ExpectedEarningsSection = () => {
  const { service } = useDeviceInfo();
  const { navigate } = useNavigate();
  const paths = getPaths(service);
  const { data: mypageData } = useQuery(curatorQueries.mypage.data());

  const expectedEarnings = mypageData?.expectedEarnings || 0;

  const handleClickMoreInfo = () => {
    if (service === SERVICE.MUSINSA) {
      amplitudeSendEvent({
        action_name: 'click',
        button_name: 'dashboard_more',
        component_name: 'button',
        event_name: 'click_button',
        from: getScreenName(),
        section_name: 'mypage_dashboard',
      });
      pushDataLayer('click_button', {
        brand_id: GTM_NOTSET_STRING,
        button_id: 'dashboard_more',
        button_name: 'goods',
        index: GTM_NOTSET_STRING,
        section_index: '3',
        section_name: 'mypage_dashboard',
      });
    } else {
      track({
        schema: SNOWPLOW_SCHEME.CLICK_BUTTON,
        data: {
          page_name: 'curator_mypage',
          section_name: 'EstimatedRevenue',
          section_title: '이번달 예상 수익',
          position: 3,
          button_id: 'more',
          button_name: '자세히 보기',
        },
      });
    }

    navigate(paths.earningsSummary());
  };

  return (
    <div className="w-full px-[16px]! pb-[16px]!">
      <div className="bg-white rounded-[4px]! py-[12px]!">
        <div className="px-[16px]!">
          <div className="flex items-center gap-[2px]">
            <Typography variant="body14pxMed">이번 달 예상 수익</Typography>
            <ExpectedEarningsInfoSheet>
              <IconButton asChild className="flex cursor-pointer" size="size16x16">
                <IcInfo />
              </IconButton>
            </ExpectedEarningsInfoSheet>
          </div>
          <div className="flex items-end gap-[8px] pt-[4px]! pb-[8px]!">
            <div className="flex-1">
              <Typography variant="title26pxMed">
                {expectedEarnings > 0 ? <PriceTypography price={expectedEarnings} /> : '0원'}
              </Typography>
            </div>
            <Typography
              onClick={handleClickMoreInfo}
              className="cursor-pointer py-[3px]!"
              variant="body13pxReg"
              textDecoration="underline"
              colorScheme="gray-600"
            >
              수익 현황
            </Typography>
          </div>
        </div>
        <div className="px-[16px]! py-[4px]!">
          <Divider variant="line" />
        </div>
        <CampaignShortcutGroup className="px-[16px]! pt-[8px]!" />
      </div>
    </div>
  );
};
